import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLogo } from '../../logoContext';
import TowerImage from '../../asset/images/hotel/ferris-wheel.svg';

import forwardIcon from '../../asset/images/icons/forward-icon.svg';

import strip from '../../asset/images/strip.svg'

import { BsFillPlusCircleFill} from 'react-icons/bs';

import SightModal from 'src/components/common/sight-modal';

const ComingSoonPage = () => {

  const logoSrc = useLogo();
  document.title = 'Coming Soon | SNB';

  const [activeSight, setActiveSight] = useState(false)
  const [sightModal, setSightModal] = useState(false)


  const closeSightModal = () => {
      setActiveSight(false)
      setSightModal(false)
  }

  useEffect(() => {
      if (activeSight){
        setSightModal(true)
      }
  }, [activeSight])


  return (
    <div className='outer-wrapper'>
      <div className='container-fluid main-content'>
        <div className='row header'>
        <Link style={{width: 'fit-content'}} to="/"><img className='ms-sm-3 ms-0' id='logo' src={logoSrc} alt='snb logo' /></Link>
          <h2 className='text-primary header-text'>2025 | SNB Nexus</h2>
        </div>

        <div className='px-4'>

        <div className="row nav">
          <div className="d-flex justify-content-end">
            <Link to="/home" className="text-decoration-none text-white">
              <button className="btn nav-btn d-flex align-items-center">
                <img src={forwardIcon} alt="" width="22%" className="me-auto" /> <span>Back</span>
              </button>
            </Link>
          </div>
        </div>

        <div className="row">

          <div className="col-lg-2 col-12">
            <h2 className="text-success fw-bolder text-start pb-3">
              Coming Soon
            </h2>
          </div>
        
        
        </div>
        </div>


      </div>


      <span className='footer'>
      <img src={TowerImage} alt="" className="ms-0 ms-md-auto d-none d-md-block wheel-small p-absolute" />
        <img src={TowerImage} alt="" className="ms-0 ms-md-auto d-block d-md-none wheel-small"/>
        <h2 className='text-primary footer-text mx-0 ps-0 mx-md-4 ps-md-3' >SNB Nexus 2026
</h2>
        <img className='strip' src={strip} alt='footer' />
      </span>

      <SightModal
        isOpen={sightModal}
        toggle={closeSightModal}
        sight={activeSight}
      />

    </div>
  );
};

export default ComingSoonPage;


